<template>
  <div>Countries</div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
